export const pageItems = [5, 10, 25, 50, 'All'];